import amaanSwapLogo from "./assets/amaan-swap-logo.png";
import evGoLogo from "./assets/ev-ready-evgo-logo.png";

export type BrandId = "amaan-swap" | "ev-ready-evgo";

export type Brand = {
  id: BrandId;
  displayName: string;
  logoSrc: string;
  logoAlt: string;
};

export const brands: Brand[] = [
  {
    id: "amaan-swap",
    displayName: "Amaan Swap",
    logoSrc: amaanSwapLogo,
    logoAlt: "Amaan Swap",
  },
  {
    id: "ev-ready-evgo",
    displayName: "EV-Ready EV-GO",
    logoSrc: evGoLogo,
    logoAlt: "EV-Ready EV-GO",
  },
];

export const getBrand = (id: string | null | undefined): Brand | undefined => {
  if (!id) return undefined;
  return brands.find((b) => b.id === id);
};
